import Axios, {AxiosInstance, AxiosPromise} from 'axios';
import ApiService from './apiService';
import BioAdmin from 'types/ba/bioAdmin';

export const BioProfileServiceAxiosInstance: AxiosInstance = Axios.create({
	baseURL: window.lt.api.ltApiUrl + '/aem/bios/v1/profile',
	headers: {
		'apiKey': window.lt.api.biosApiKey,
	},
});

export default class BioProfileService extends ApiService implements BioAdmin.IBioProfileService {
	constructor() {
        super('bio-profile-service', BioProfileServiceAxiosInstance);
    }

	public getProfile(employeeId: string): AxiosPromise<BioAdmin.IBioProfile> {
		const config = {
			headers: { Pragma: 'no-cache'},
		};
		if (employeeId) {
			return this.axiosInstance.get('/' + employeeId, config);
		} else {
			return this.axiosInstance.get('', config);
		}
	}

	public setBioProfile(profile: BioAdmin.IBioProfile): AxiosPromise<BioAdmin.IBioProfileResponse> {
		return this.axiosInstance.post('', profile);
	}

	public updateProfileStatus(employeeId: number, data: BioAdmin.IBioProfileStatus): AxiosPromise<BioAdmin.IBioProfileResponse> {
		return this.axiosInstance.post('/' + employeeId + '/approval', data);
	}

	public fixProfileStatus(): AxiosPromise<BioAdmin.IBioProfileResponse> {
		return this.axiosInstance.post('/fixProfileStatus');
	}

	public setVisibility(employeeId: number, value: boolean): AxiosPromise<BioAdmin.IBioProfileResponse> {
		const data: BioAdmin.IBioProfileVisibility = {
			visible: value,
		};
		return this.axiosInstance.post('/' + employeeId + '/visibility', data);
	}

	public setPromoted(employeeId: number, value: boolean): AxiosPromise<BioAdmin.IBioProfileResponse> {
		const data: BioAdmin.IBioProfilePromoted = {
			promote: value,
		};
		return this.axiosInstance.post('/' + employeeId + '/promote', data);
	}

	public setDPTFlag(employeeId: number, value: boolean): AxiosPromise<BioAdmin.IBioProfileResponse> {
		const data: BioAdmin.IBioProfileDPTEnabled = {
			dptFlag: value,
		};
		return this.axiosInstance.post('/' + employeeId + '/dptFlag', data);
	}

	public getTestimonials(employeeId: number): AxiosPromise<BioAdmin.ITestimonial[]> {
		if (employeeId) {
			return this.axiosInstance.get('/' + employeeId + '/testimonials');
		} else {
			return this.axiosInstance.get('/testimonials');
		}
	}

	public setTestimonialVisibility(employeeId: number, testimonialId: number, value: boolean): AxiosPromise<BioAdmin.IBioProfileResponse> {
		const data: BioAdmin.ITestimonialVisibility = {
			visible: value,
		};
		return this.axiosInstance.post('/' + employeeId + '/testimonials/' + testimonialId + '/visibility', data);
	}

	public setTestimonialStatus(employeeId: number, testimonialId: number, value: string): AxiosPromise<BioAdmin.IBioProfileResponse> {
		const data: BioAdmin.ITestimonialStatus = {
			action: value,
		};
		return this.axiosInstance.post('/' + employeeId + '/testimonials/' + testimonialId + '/approval', data);
	}

	public editTestimonialText(employeeId: number, testimonialId: number, text: string): AxiosPromise<BioAdmin.IBioProfileResponse> {
		const data: BioAdmin.IEditTestimonialText = {
			testimonial: text,
		};
		return this.axiosInstance.put('/' + employeeId + '/testimonials/' + testimonialId, data);
	}
}
